import Localization from 'lib/localization';

export default {
  tab: {
    title() {
      return Localization.get('bumblesite@privacy.security.tab.title');
    },
    text() {
      return Localization.get('bumblesite@privacy.security.tab.text1');
    },
    introList() {
      return Localization.get('bumblesite@privacy.security.tab.text2');
    },
    text2() {
      return Localization.get('bumblesite@privacy.security.tab.text2');
    },
    listTitle() {
      return Localization.get('bumblesite@privacy.informationDisclosure.tab.contents.title');
    },
    list() {
      return [
        Localization.get('bumblesite@privacy.security.tab.list.item1'),
        Localization.get('bumblesite@privacy.security.tab.list.item2'),
      ];
    },
  },
  section1: {
    text1() {
      return Localization.get('bumblesite@privacy.security.section1.text1');
    },
    text2() {
      return Localization.get('bumblesite@privacy.security.section1.text2');
    },
    text3() {
      return Localization.get('bumblesite@privacy.security.section1.text3');
    },
    text4() {
      return Localization.get('bumblesite@privacy.security.section1.text4');
    },
  },
  section2: {
    title() {
      Localization.get('bumblesite@privacy.security.section2.title');
    },
    text1() {
      return Localization.get('bumblesite@privacy.security.section2.text1');
    },
    text2() {
      return Localization.get('bumblesite@privacy.security.section2.text2');
    },
  },
};
